import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { checkCharge } from "@/redux/slices/events/eventsSlice"
import { setLoading } from "@/redux/slices/auth/authSlice"
import Preloader from "@/components/utils/Preloader/Preloader"
import "./ResultPage.scss"

const ResultPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { success } = useAppSelector((state) => state.events)

  useEffect(() => {
    dispatch(setLoading())
    setTimeout(
      () =>
        dispatch(
          checkCharge({
            charge_id: new URLSearchParams(window.location.search).get(
              "tap_id",
            ),
          }),
        ),
      5000,
    )
  }, [dispatch])

  return (
    <>
      <div className="result">
        <div className="container">
          {success === "" ? (
            <Preloader />
          ) : success === "false" ? (
            <div className="result-main">
              <div className="result-left">
                <h2 className="caption-two result-title">
                  Sorry, your payment failed
                </h2>
                <h4 className="result-description">
                  Please check your payment details or try again later
                </h4>
                <button
                  className="btn btn-dark result-button"
                  onClick={() => navigate(`/credits`)}
                >
                  Try Again
                </button>
              </div>
              <div className="result-right">
                <img
                  className="result-picture"
                  src="../../../images/payment-failed.png"
                  alt=""
                />
              </div>
            </div>
          ) : (
            <div className="result-main">
              <div className="result-left">
                <h2 className="caption-two result-title">
                  Payment for the package was successful!
                </h2>
                <div className="result-buttons">
                  <span
                    className="btn btn-simple"
                    onClick={() => navigate(`/profile`)}
                  >
                    Profile
                  </span>
                  <button
                    className="btn btn-dark"
                    onClick={() => navigate(`/`)}
                  >
                    To Home Page
                  </button>
                </div>
              </div>
              <div className="result-right">
                <img
                  className="result-picture"
                  src="../../../images/payment-successful.png"
                  alt=""
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default ResultPage
